import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { UserProfileEditInterface } from "../../../middleware/interfaces/user/user-profile-edit-interface";

export const UserProfileEdit = {
  Edit: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const userProfileEditData: UserProfileEditInterface = state.data;
      const url = "./php/user/user-profile-editor-proxy.php";
      await axios
        .post(url, userProfileEditData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = "SOMETHING WENT WRONG! PLEASE CONTACT ADMIN.";
    }

    return serverResponse;
  },
};
